export type AppTheme = 'light' | 'dark';

const STORAGE_KEY = 'pdfka:theme';
const DEFAULT_THEME: AppTheme = 'light';

export function initTheme(): AppTheme {
  const theme = getTheme();
  applyTheme(theme);
  return theme;
}

export function getTheme(): AppTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function setTheme(theme: AppTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // The visual state still changes even when storage is unavailable.
  }
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent('pdfka:theme-change', { detail: theme }));
}

function applyTheme(theme: AppTheme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute(
    'content',
    theme === 'dark' ? '#0f172a' : '#ffffff',
  );
}
